"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
;
;
var HospitalName = /** @class */ (function (_super) {
    __extends(HospitalName, _super);
    function HospitalName(props) {
        var _this = _super.call(this, props) || this;
        var state = form_store_1.default.getState();
        _this.state = {
            value: state.data.hospital_name,
            error: state.error.hospital_name
        };
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            if (_this._isMounted) {
                _this.setState({
                    value: state.data.hospital_name,
                    error: state.error.hospital_name
                });
            }
        });
        return _this;
    }
    HospitalName.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    HospitalName.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    HospitalName.prototype.render = function () {
        var _a = this.state, value = _a.value, error = _a.error, errorElem = (react_1.default.createElement(react_1.default.Fragment, null));
        if (error.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "form-error" }, error[0]));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorElem,
            react_1.default.createElement("input", { className: "input-text", type: "text", name: "hospital_name", defaultValue: value, onChange: input_actions_1.default.changeInput })));
    };
    return HospitalName;
}(react_1.Component));
exports.default = HospitalName;
